function checkForElement(target, attempt = 1) {
  const maxAttempts = 5; 
  if (attempt > maxAttempts) return; 
  
  const liElement = target.closest('.size-option');
  const getVariant = liElement.getAttribute('getvariant');
  const getHandle = liElement.getAttribute('gethandle');
  const getSize = liElement.getAttribute('getsize');

  const quickBuyModal = document.querySelector(`quick-buy-modal[handle="${getHandle}"]`);
  if (quickBuyModal) {
    const radioInput = quickBuyModal.querySelector(`input[type="radio"][name="option1"] + label[labelvalue="${getSize}"]`);
    if (radioInput) {
      const radioInputId = radioInput.getAttribute('for');
      const actualRadioInput = document.getElementById(radioInputId);
      if (actualRadioInput) {
        actualRadioInput.checked = true;
        const form = quickBuyModal.querySelector('.shopify-product-form');
        const idInput = form.querySelector('input[name="id"]');
        
        if (idInput) {
          idInput.value = getVariant;
          if (document.getElementById("size_selected")) {
            document.getElementById("size_selected").innerHTML = getSize;
          }
        }

        return;  
      }
    }
  }
  setTimeout(() => checkForElement(target, attempt + 1), 600);
}

document.addEventListener('click', function(event) {
  const target = event.target;
  if (target.classList.contains('size-button')) {
    checkForElement(target);
  }
});
